import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchContentPageById } from 'core/actions/ocapi';

import DynamicPageComponent
  from 'core/modules/DynamicRewardsPageContent/components/DynamicPageComponent/DynamicPageComponent';

import {
  selectDynamicRewardsTabContentConfig, makeSelectDynamicRewardsTabContentData,
  makeSelectDynamicRewardsTabContentIsLoading, makeSelectDynamicRewardsTabContentIsLoaded,
} from './selectors';

import { triggerDynamicRewardsTabContentIsViewed } from './actions';

function DynamicRewardsTabContent({ activeTabLink }) {
  const dispatch = useDispatch();

  const selectDynamicRewardsTabContentData = makeSelectDynamicRewardsTabContentData();
  const selectDynamicRewardsTabContentIsLoading = makeSelectDynamicRewardsTabContentIsLoading();
  const selectDynamicRewardsTabContentIsLoaded = makeSelectDynamicRewardsTabContentIsLoaded();

  const config = useSelector(selectDynamicRewardsTabContentConfig);
  const isLoading = useSelector(state => selectDynamicRewardsTabContentIsLoading(state, activeTabLink));
  const isLoaded = useSelector(state => selectDynamicRewardsTabContentIsLoaded(state, activeTabLink));
  const data = useSelector(state => selectDynamicRewardsTabContentData(state, activeTabLink));

  const getTabContent = () => {
    if (activeTabLink) {
      const { api: { params, options } = {} } = config;
      dispatch(fetchContentPageById(activeTabLink, params, { ...options, namespace: activeTabLink }));
    }
  };

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      getTabContent();
    }
  });

  useEffect(() => {
    if (activeTabLink) {
      dispatch(triggerDynamicRewardsTabContentIsViewed(activeTabLink));
    }
  }, [activeTabLink]);

  if (isEmpty(data)) {
    return null;
  }

  const { slots } = data;
  const { components } = slots[0];

  return (
    <div className="mn_dynamicRewardsTab" data-test="dynamic-rewards-tab-content">
      <DynamicPageComponent components={components} />
    </div>
  );
}

export default DynamicRewardsTabContent;
